import AbstractServiceNavigationBehaviour from './abstract-service-navigation-behaviour';

export default class ExpandTopBehaviour extends AbstractServiceNavigationBehaviour {
    /**
     * @return {boolean}
     */
    shouldExpand() {
        return document.documentElement.scrollTop < 200;
    }
}
